<div class="container-fluid footer-container" [style.margin-left.px]="leftOffset">
  <div class="d-flex justify-content-between align-items-center">

    <ng-container *jargonViewMode="'notes:finalize'">
      <button class="px-3 btn btn-primary" (click)="submit()"
              [jargonLoadingState]="['builder-control', 'builder-submission']">
        {{
        isSaving
        ? "Submitting Clinical Notes..."
        : "Finalise Clinical Notes (Push to EHR)"
        }}
      </button>
    </ng-container>

    <ng-container *jargonViewMode="'notes:write'">
      <button class="px-3 btn btn-primary" (click)="save()"
              [jargonLoadingState]="['builder-control', 'builder-submission']">
        {{ isSavingSections ? "Saving Clinical Notes..." : "Save Clinical Notes" }}
      </button>
    </ng-container>

    <ng-container *jargonViewMode="'review:write'">
      <button class="px-3 btn btn-primary" (click)="submitReview()"
              [jargonLoadingState]="['builder-control', 'builder-submission']">
        Submit Review
      </button>
    </ng-container>

  </div>
</div>